module.exports = __webpack_public_path__ + "static/media/notes4.b165b4f7.png";